var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FFF9E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2C18.4478 2 21.7544 3.36964 24.1924 5.80761L15 15V2Z",
    fill: "#FFC814"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewed);
export default __webpack_public_path__ + "static/media/reviewed.7f53b9bfc8191287a5364d550bfda707.svg";
export { ForwardRef as ReactComponent };